import React, { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { labelSizeClass } from './labelSize';

function formatDigits(digits: string, decimals: number): string {
    const divisor = Math.pow(10, decimals);
    const num = parseInt(digits || '0', 10);
    return (num / divisor).toLocaleString('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

export default function UiInputMoney({ label, name, size, labelSize, asTable, className, decimals = 2, suffix, ...rest }: any) {
    const { register, setValue, watch } = useFormContext();
    const externalValue = watch(name);
    const [digits, setDigits] = useState('');
    const replaceOnType = useRef(false);
    const divisor = Math.pow(10, decimals);

    useEffect(() => {
        register(name);
    }, [register]);

    useEffect(() => {
        const centsFromExternal = externalValue != null ? Math.round(externalValue * divisor) : 0;
        const centsFromDigits = digits ? parseInt(digits, 10) : 0;
        if (centsFromExternal !== centsFromDigits) {
            setDigits(centsFromExternal === 0 ? '' : String(centsFromExternal));
        }
    }, [externalValue]);

    const handleFocus = () => {
        replaceOnType.current = true;
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key >= '0' && e.key <= '9') {
            e.preventDefault();
            const hasSelection = e.currentTarget.selectionStart !== e.currentTarget.selectionEnd;
            const base = (replaceOnType.current || hasSelection) ? '' : digits;
            replaceOnType.current = false;
            const newDigits = base + e.key;
            setDigits(newDigits);
            setValue(name, parseInt(newDigits, 10) / divisor);
        } else if (e.key === 'Backspace') {
            e.preventDefault();
            replaceOnType.current = false;
            const newDigits = digits.slice(0, -1);
            setDigits(newDigits);
            setValue(name, newDigits ? parseInt(newDigits, 10) / divisor : 0);
        }
    };

    const prefix = suffix ? '' : 'R$ ';
    const placeholder = suffix ? `0${decimals > 0 ? ',' + '0'.repeat(decimals) : ''}` : `R$ 0,${'0'.repeat(decimals)}`;
    const displayValue = digits ? `${prefix}${formatDigits(digits, decimals)}` : '';

    return (
        <div className={`col-lg-${size ?? 12}`}>
            <div className={`form-item${labelSizeClass(labelSize)}`}>
                {!asTable && <label className="form-label">{label}</label>}
                <div className={`field-container${suffix ? ' with-suffix' : ''}`}>
                    <input
                        type="text"
                        value={displayValue}
                        onKeyDown={handleKeyDown}
                        onFocus={handleFocus}
                        onChange={() => {}}
                        placeholder={placeholder}
                        className={`form-control ${className ?? ''}`}
                        {...rest}
                    />
                    {suffix && <span className="field-suffix">{suffix}</span>}
                </div>
            </div>
        </div>
    );
}
